import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'app/auth';

import StaffListGate from 'app/main/apps/staff/list/StaffListGate';

const Product = lazy(() => import('./product/Product'));
const Order = lazy(() => import('./order/Order'));
const OrderImports = lazy(() => import('./orders/orderImports/OrderImports'))
const SingleOrderImports = lazy(() => import('./orders/orderImports/SingleOrderImports'))
const RequestQuote = lazy(() => import('./order/RequestQuote'));
const ShipmentProductImageHandler = lazy(() => import('../backoffice/shipment/ProductImages/ShipmentProductImageHandler'));
const ReorderPage = lazy(() => import('./order/Reorder/ReorderPage'));
const RestockPage = lazy(() => import('./restock/RestockPage'));
const OrderBoxLabelsPage = lazy(() => import('./order/BoxLabels/OrderBoxLabelsPage'));
  
const ECommerceAppConfig = {
  settings: {
    layout: {},
  },
  auth: authRoles.staff,
  routes: [
    {
      path: 'orders',
      element: <StaffListGate type="order" for="orders" module="orders" />,
    },
    {
      path: 'orders/imports',
      element: <OrderImports />,
    },
    {
      path: 'orders/single-imports',
      element: <SingleOrderImports type='orders' />
    },
    {
      path: 'products/price-book-imports',
      element: <SingleOrderImports type='price_book' />
    },
    {
      path: 'products/restock',
      element: <RestockPage />,
    },
    {
      path: 'products/:productId/*',
      element: <Product />,
    },
    {
      path: 'orders/:orderId',
      element: <Order type="order" module="orders" />,
    },
    {
      // PGSS-5748 part 2b: staff print box labels for a customer order, or for a container's orders still to ship.
      path: 'orders/:orderId/box-labels',
      element: <OrderBoxLabelsPage />,
    },
    {
      path: 'shipments/containers/:shipmentId/box-labels',
      element: <OrderBoxLabelsPage />,
    },
    {
      path: 'rfq/:orderId',
      element: <Order type="rfq" module="rfqs" />,
    },
    {
      path: 'quotes/:orderId',
      element: <Order type="quote" module="quotes" />,
    },
    {
      path: 'rfqs/:orderId',
      element: <Order type="rfq" module="rfqs" />,
    },
    {
      path: '/shipments/reviewProductImages/:shipmentId',
      element: <ShipmentProductImageHandler type="review" />
    }, 
    {
      path: 'reorder',
      element: <ReorderPage type="order" for="orders" module="orders" />,
    },
    {
      // PGSS-5344: Restock is the second tab of Products. The old link still works.
      path: 'sales-reorder',
      element: <Navigate to="/products/restock" replace />,
    },
  ],
};

export default ECommerceAppConfig;
